import React, { useEffect, useMemo, useState } from "react";
import "./Cart.scss";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useDispatch, useSelector } from "react-redux";
import { removeItem, resetCart, updateQuantity } from "../../redux/cartReducer";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { IoCloseOutline } from "react-icons/io5";

const Cart = ({close}) => {
  const cartProducts = useSelector((state) => state.cart.products);
  const dispatch = useDispatch();
  const [isCheckout, setIsCheckout] = useState(false);
  const [savedQrCode, setSavedQrCode] = useState(null);
  const [codeStatus, setCodeStatus] = useState(null);

  //console.log(products);

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const offerProduct = params.get("offerProduct");
  const qrCode = params.get("qrCode");

  const [savedOfferProduct, setSavedOfferProduct] = useState(null);

  const qrApiUrl = process.env.REACT_APP_QR_API_URL;

  // Save to sessionStorage if available in URL
  useEffect(() => {
    if (offerProduct) {
      try {
        sessionStorage.setItem("offerProduct", offerProduct);
        sessionStorage.setItem("qrCode", qrCode);
      } catch (e) {
        // ignore sessionStorage quota errors
      }
    }
  }, [offerProduct]);

  // Load from sessionStorage
  useEffect(() => {
    const stored = sessionStorage.getItem("offerProduct");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setSavedOfferProduct(parsed);
      } catch (e) {
        // ignore malformed sessionStorage data
      }
    }
  }, []);

  useEffect(() => {
    const stored = sessionStorage.getItem("qrCode");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setSavedQrCode(parsed);
      } catch (e) {
        // ignore malformed sessionStorage data
      }
    }
  }, []);

  useEffect(() => {
    if (!savedQrCode) {
      return;
    }
    const getVarifyCode = async () => {
      try {
        const response = await axios.get(`${qrApiUrl}/check-qr/${savedQrCode}`);
        setCodeStatus(response.data);
        sessionStorage.setItem("status", response.data.status);
      } catch (error) {
        return;
      }
    };
    getVarifyCode();
  }, [savedQrCode]);

  //!offer product section ..

  const code = codeStatus?.value || " ";
  const status = codeStatus?.status || " ";

  const combinedProducts = useMemo(() => {
    if (savedQrCode === code && status === "new") {
      if (savedOfferProduct) {
        return [...cartProducts, savedOfferProduct];
      }
      return cartProducts;
    } else {
      return cartProducts;
    }
  }, [savedQrCode, code, status, cartProducts, savedOfferProduct]);

  //!offer product section ..end......

  const delivaryAmout = 20;
  const delivaryAmoutLess = 10;
  const noDelivaryAmout = 0;

  const totalPrice = () => {
    let total = 0;
    cartProducts.forEach((item) => (total += item.quantity * item.price));
    return total.toFixed(2);
  };

  const netOder = Math.min(totalPrice());
  const withDelivaryCost = () => {
    if (netOder < 50) {
      const netTotal = netOder + delivaryAmout;
      return netTotal.toFixed(2);
    }
    if (netOder >= 50 && netOder < 75) {
      const netTotal = netOder + delivaryAmoutLess;
      return netTotal.toFixed(2);
    }
    if (netOder >= 75) {
      const netTotal = netOder + noDelivaryAmout;
      return netTotal.toFixed(2);
    } else {
      return;
    }
  };

  const finalCost = withDelivaryCost();
  let FinalNetPrice = withDelivaryCost();

  const massageDisplay_75 = () => {
    if (netOder < 75) {
      let value = 75 - netOder;
      return ` You're just AED ${value.toFixed(2)} away from free delivery! `;
    } else {
      return " 🥳  Woo.. hoo.. you're eligible for free delivery 🚚 ";
    }
  };

  const massgeDisplay_50 = () => {
    if (netOder < 50) {
      let valueTwo = 50 - netOder;
      return ` Or,Add just AED ${valueTwo.toFixed(
        2
      )} to slash your delivery fee to AED 10.`;
    } else {
      return;
    }
  };

  const comMessage = " 'Don't miss out—shop a little more and save big! ";
  const inital = netOder === 0 ? "hide" : "";

  const handleCheckout = () => {
    setIsCheckout(true);
  };

  return (
    <>
      {!isCheckout && (
        <div className="cart">
          <div className="cart_wrap" style={{ padding: "20px" }}>
            <div className="close_wrp" onClick={close}>
              <span>
                {" "}
                Close Cart <IoCloseOutline color="red" size={18} />
              </span>
            </div>
            {status === "used" && (
              <div className="arlat">
                <small>
                  QR code has already been used. Please try a new one.
                </small>
              </div>
            )}
            <h2 className="cart-head"> Product in your cart</h2>

            {combinedProducts?.map((item, i) => (
              <div className="item" key={i}>
                <img src={process.env.REACT_APP_UPLOAD_URL + item.img} alt="" />
                <div className="details">
                  <strong style={{ fontSize: "15px", fontWeight: "600" }}>
                    {item.title} - {item.weight}
                  </strong>

                  <p style={{ lineHeight: "1.2", fontSize: "12px" }}>
                    {item.desc?.substring(0, 50)}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <strong style={{ fontSize: "12px" }}>
                      Qty {item.quantity} x AED {item.price}
                    </strong>
                    <div>
                      <button
                        onClick={() =>
                          dispatch(
                            updateQuantity({
                              id: item.id,
                              quantity:
                                item.quantity === 1 ? 1 : item.quantity - 1,
                            })
                          )
                        }
                      >
                        -
                      </button>
                      <strong style={{ margin: "0px 20px", fontSize: "12px" }}>
                        {item.quantity}
                      </strong>

                      <button
                        onClick={() =>
                          dispatch(
                            updateQuantity({
                              id: item.id,
                              quantity: item.quantity + 1,
                            })
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <DeleteOutlinedIcon
                  className="delete"
                  onClick={() => dispatch(removeItem(item.id))}
                />
              </div>
            ))}

            <div className="total">
              <span>Products Total</span>
              <span>AED {totalPrice()}</span>
            </div>

            <div className="total">
              <span>Delivery Charges</span>
              {netOder < 50 ? (
                <p>AED 20.00</p>
              ) : netOder >= 50 && netOder < 75 ? (
                <p>AED 10.00</p>
              ) : (
                <p>Free</p>
              )}
            </div>

            <div className="sub_total">
              <span>SUBTOTAL</span>
              <div className={`${netOder === 0 ? "hide" : ""}`}>
                <span>AED {FinalNetPrice}</span>
              </div>
            </div>
            <div className="delivaryMsg">
              <span style={{ fontWeight: 400 }}>
                {massageDisplay_75()}
                {massgeDisplay_50()}
                Don't miss out—shop a little more and save big!
              </span>
            </div>
            <Link
              to={{
                pathname: "/check_out",
                state: { cartProducts, finalCost },
              }}
            >
              <button className="checkout" onClick={handleCheckout}>
                PROCEED TO CHECKOUT
              </button>
            </Link>
            <span className="reset" onClick={() => dispatch(resetCart())}>
              Reset Cart
            </span>
            {/* <div className="freeDel">
              <span>
                <strong>*</strong> Free home delivery on orders over{" "}
                <strong>AED 75</strong> —no extra fees, just great value! <br />{" "}
                <strong>*</strong>For orders between <strong>AED 50</strong> and
                <strong>AED 75</strong>, enjoy delivery for only{" "}
                <strong>AED 10</strong>. <br /> <strong>*</strong> Orders below
                <strong>AED 50</strong> incur a delivery charge of{" "}
                <strong>AED 20</strong>.
              </span>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Cart;
